// src/pages/campaign-console/ReadinessRing.jsx
// Circular "N/5 steps complete" ring used in the rail and the detail header.
import React from 'react';

export default function ReadinessRing({
  done, total = 5, size = 44, thick = 4,
  color = '#2f5bd0', track = '#eef1f5', label = true,
}) {
  const r = (size - thick) / 2;
  const circ = 2 * Math.PI * r;
  const p = total ? done / total : 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flex: 'none' }} aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={thick} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={thick}
        strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={circ * (1 - p)}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset .4s ease' }}
      />
      {label && (
        <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle"
          fontSize={size * 0.3} fontWeight="700" fill={color} fontFamily="'IBM Plex Mono', monospace">
          {done}/{total}
        </text>
      )}
    </svg>
  );
}
